import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../../components/ErpTemplate';
import { FaBan, FaCheck, FaSave, FaTrash } from 'react-icons/fa';
import api from '../../../services/api';
import { useHistory, useLocation } from 'react-router-dom';
import { bin2hex, extract } from '../../../util/util';
import { toast } from 'react-toastify';
import MostrarHTML from '../../../components/MostrarHtml';
import { getText, getParticipantLanguage } from '../../../util/translations';

export default function CadastroEventoParticipanteAceitarConvite({ match }) {
    let elementoAssinatura = null;
    const id = match.params.id;
    const token = localStorage.getItem('token');
    const perfil = localStorage.getItem("perfil");
    const [data, setData] = useState(null);
    const [concordaConvite, setConcordaConvite] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    const [cpfInicial, setCpfInicial] = useState(null);
    const history = useHistory();
    const { state } = useLocation();
    const idioma = data?.idioma || state?.idioma || null;
    const params = new URLSearchParams(window.location.search);
    const contrato = params.get('contrato');

    const buscar = () => {
        setIsLoading(true);
        setIsError(false);
        api({
            method: "get",
            action: '/participante/' + id,
            token: token,
        }).then(response => {
            //extrai dados internos para o array principal
            var dadosRecebidos = extract({
                jsonLaravel: response.data.data,
                chaves: [
                    'enderecopais',
                    'aereomunicipioembarque',
                    'enderecomunicipio',
                    'banco',
                ]
            });

            //se estiver em alguma situação do grupo "confirmado" ou "declinaram", mostrar concluído
            var gruposSituacao = dadosRecebidos.grupoSituacao ?? [];
            if (gruposSituacao.includes("confirmados") || gruposSituacao.includes("declinaram")) {
                history.push({
                    pathname: "/cadastroEventoParticipanteConviteConcluido/" + dadosRecebidos.evento.id,
                    state: { idioma: dadosRecebidos.idioma }
                });
                return;
            }

            // Armazena o CPF inicial
            setCpfInicial(dadosRecebidos.cpf || '');

            dadosRecebidos.evento.camposQuestionario = dadosRecebidos.evento.camposQuestionario ?
                JSON.parse(dadosRecebidos.evento.camposQuestionario) :
                {
                    "tipoparticipante": "sim",
                    "nome": "sim",
                    "assinaturaListaPresenca": "sim",
                    "telefone": "sim",
                    "email": "sim",
                    "especialidade": "sim",
                    "rg": "sim",
                    "crm": "sim",
                    "crmuf": "sim",
                    "datanascimento": "sim",
                    "cpf": "sim",
                    "enderecologradouro": "sim",
                    "endereconumero": "sim",
                    "enderecocomplemento": "sim",
                    "enderecocep": "sim",
                    "enderecobairro": "sim",
                    "enderecomunicipionome": "sim",
                    "enderecomunicipiouf": "sim",
                };

            if ((dadosRecebidos.datacartaassinada ?? "") === '') {//se ainda nao aceitou
                api({
                    method: "get",
                    action: '/eventoCarta/visualizarCartaHtml/' + id,
                    token: token,
                    params: {
                        tipoCarta: "modelocartaconvite",
                    }
                }).then(response => {
                    setData({
                        ...dadosRecebidos,
                        ...{ htmlCartaConvite: response.data.data.htmlCarta }
                    });
                    setIsLoading(false);
                }).catch(function (error) {
                    const msg = idioma
                        ? `${getText('error', idioma)} ${getText('errorLoadingDefault', idioma)}`
                        : <>{getText('error', 'portugues')} {getText('errorLoadingDefault', 'portugues')}<br />({getText('error', 'ingles')} {getText('errorLoadingDefault', 'ingles')})</>;
                    toast.error(msg);
                    setIsLoading(false);
                    setIsError(true);
                });
            } else { //já aceitou a carta convite
                history.push("/cadastroEventoParticipanteConvite/" + id, { idioma: data?.idioma });
            }
        }).catch(function (error) {
            setIsLoading(false);
            setIsError(true);
            const message = idioma
                ? `${getText('error', idioma)} ${getText('errorLoadingDefault', idioma)}`
                : <>{getText('error', 'portugues')} {getText('errorLoadingDefault', 'portugues')}<br />({getText('error', 'ingles')} {getText('errorLoadingDefault', 'ingles')})</>;
            toast.error(message);
        });
    };//buscar

    const validar = () => {
        if ((data?.evento?.camposQuestionario?.vinculoOrgaoPublico ?? "nao") === "sim") {
            var vinculoOrgaoPublico = document.querySelector("#vinculoOrgaoPublico");
            if ((data?.vinculoOrgaoPublico ?? '') === '') {
                toast.error(getText('requiredVinculoOrgaoPublico', idioma));
                setTimeout(() => {
                    vinculoOrgaoPublico.focus();
                }, 500);
                return false;
            }

            // Validação para especificação do vínculo
            if ((data?.vinculoOrgaoPublico === 'sim' || data?.vinculoOrgaoPublico === 'outro') &&
                (!data?.especificacaoVinculo || data?.especificacaoVinculo.trim() === '')) {
                toast.error('É necessário especificar o vínculo com órgão público');
                return false;
            }
        }

        // Validação do CPF
        if (((data?.evento?.camposQuestionario?.cpfAssinatura ?? "nao") === "sim") &&
            (!data?.cpf || data?.cpf.trim() === '')) {
            toast.error('É necessário informar o CPF');
            setTimeout(() => {
                document.getElementById('cpf').focus();
            }, 500);
            return false;
        }

        return true;
    };

    const salvar = async (aceitouConvite) => {
        if (!validar()) {
            return false;
        }

        setIsSubmitting(true);

        api({
            method: 'put',
            action: '/participante/aceitarConvite/' + id,
            token: token,
            data: {
                aceitouConvite: aceitouConvite ? 'sim' : 'nao',
                contrato: contrato ? 'sim' : 'nao',
                vinculoOrgaoPublico: data?.vinculoOrgaoPublico ?? null,
                especificacaoVinculo: data?.especificacaoVinculo ?? null,
                cpf: data?.cpf ?? null,
                imagemassinatura: data?.imagemassinatura ?? null,
                binarioImagemAssinatura: elementoAssinatura ? bin2hex(elementoAssinatura.getCanvas().toDataURL('image/png')) : null
            },
        })
            .then(function (response) {
                if (aceitouConvite) {
                    if (contrato) {
                        history.push("/cadastroEventoParticipanteContratoEnviado/" + (data?.evento?.id ?? ""), { idioma: data?.idioma });
                    } else {
                        if ((data?.evento?.modelotermoaceite ?? "") !== "") {
                            history.push("/cadastroEventoParticipanteAceitarTermo/" + id, { idioma: data?.idioma });
                        } else {
                            history.push("/cadastroEventoParticipanteConvite/" + id, { idioma: data?.idioma });
                        }
                    }
                } else {
                    history.push("/cadastroEventoParticipanteConviteRecusado/" + data?.evento?.id, { idioma: data?.idioma });
                }
            })
            .catch(function (error) {
                const message = idioma
                    ? `${getText('error', idioma)} ${getText('errorSavingDefault', idioma)}`
                    : <>{getText('error', 'portugues')} {getText('errorSavingDefault', 'portugues')}<br />({getText('error', 'ingles')} {getText('errorLoadingDefault', 'ingles')})</>;
                toast.error(message);
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    useEffect(() => { //onload
        if (data?.base64assinatura) {
            if (elementoAssinatura)
                elementoAssinatura.fromDataURL("data:image/png;base64," + data.base64assinatura, { ratio: 1 });
        }
    },
        // eslint-disable-next-line
        [data?.base64assinatura]);

    useEffect(() => { //onload
        buscar();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate sidebar={['listarsvp', 'cliente'].includes(perfil) ? false : true} processando={isLoading} idioma={idioma ?? "both"}>
            <div className="main-content container-fluid">
                <div className="page-title">
                    <h3>{getText('aceitarConvite', idioma)}</h3>
                </div>
                <section id="multiple-column-form">
                    <div className="row match-height">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-content">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <MostrarHTML
                                                    htmlContent={data?.htmlCartaConvite ?? null}
                                                />
                                            </div>
                                        </div>

                                        {!isLoading && !isError && data?.evento && (
                                            <>
                                                {(data?.evento?.camposQuestionario?.vinculoOrgaoPublico ?? "nao") === "sim" ?
                                                    <div className="row" style={{ marginBottom: "20px" }}>
                                                        <div className="col-sm-4">
                                                        </div>
                                                        <div className="col-sm-4">
                                                            <div className="row">
                                                                <div className="col-sm-12">
                                                                    <div className="form-check">
                                                                        <div className="checkbox">
                                                                            <label>
                                                                                <input type="radio"
                                                                                    className="form-check-input"
                                                                                    value="nao"
                                                                                    checked={data?.vinculoOrgaoPublico === "nao"}
                                                                                    onChange={() => {
                                                                                        data.vinculoOrgaoPublico = "nao";
                                                                                        setData({ ...data });
                                                                                    }} />
                                                                                {getText('noVinculoOrgaoPublico', idioma)}
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-sm-12">
                                                                    <div className="form-check">
                                                                        <div className="checkbox">
                                                                            <label>
                                                                                <input
                                                                                    id="vinculoOrgaoPublico"
                                                                                    type="radio"
                                                                                    className="form-check-input"
                                                                                    value="sim"
                                                                                    checked={data?.vinculoOrgaoPublico === "sim"}
                                                                                    onChange={() => {
                                                                                        data.vinculoOrgaoPublico = "sim";
                                                                                        setData({ ...data });
                                                                                    }} />
                                                                                {getText('vinculoOrgaoPublico', idioma)}
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-sm-12">
                                                                    <div className="form-check">
                                                                        <div className="checkbox">
                                                                            <label>
                                                                                <input
                                                                                    id="vinculoOrgaoPublico"
                                                                                    type="radio"
                                                                                    className="form-check-input"
                                                                                    value="outro"
                                                                                    checked={data?.vinculoOrgaoPublico === "outro"}
                                                                                    onChange={() => {
                                                                                        data.vinculoOrgaoPublico = "outro";
                                                                                        setData({ ...data });
                                                                                    }} />
                                                                                {getText('otherVinculoOrgaoPublico', idioma)}
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row" style={{ marginTop: "10px" }}>
                                                                <div className="col-sm-12">
                                                                    <textarea
                                                                        className="form-control"
                                                                        rows="4"
                                                                        placeholder={getText('specifyVinculoOrgaoPublico', idioma)}
                                                                        value={data?.especificacaoVinculo || ''}
                                                                        onChange={(e) => {
                                                                            data.especificacaoVinculo = e.target.value;
                                                                            setData({ ...data });
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    : null}

                                                {(data?.evento?.camposQuestionario?.cpfAssinatura === "sim" && (!cpfInicial || cpfInicial.trim() === '')) && (
                                                    <div className="row" style={{ marginTop: "20px" }}>
                                                        <div className="col-sm-4">
                                                        </div>
                                                        <div className="col-sm-4">
                                                            <div className="form-group">
                                                                <label htmlFor="cpf">{getText('cpf', idioma)} *</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="cpf"
                                                                    placeholder={getText('enterCpf', idioma)}
                                                                    value={data?.cpf || ''}
                                                                    onChange={(e) => {
                                                                        data.cpf = e.target.value;
                                                                        setData({ ...data });
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                <div className="row">
                                                    <div className="col-sm-12 d-flex justify-content-end">
                                                        <div className="form-check">
                                                            <div className="checkbox">
                                                                <label>
                                                                    <input type="checkbox"
                                                                        className="form-check-input"
                                                                        value={concordaConvite}
                                                                        checked={concordaConvite}
                                                                        onChange={(value) => {
                                                                            setConcordaConvite(!concordaConvite);
                                                                        }} />
                                                                    {getText('agreeWithTerms', idioma)}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-12 d-flex justify-content-end">
                                                        <button
                                                            type="button"
                                                            className="btn btn-danger me-1 mb-1"
                                                            disabled={isSubmitting}
                                                            onClick={() => { salvar(false); }}
                                                        >
                                                            <FaBan size={20} /> {getText('declineInvite', idioma)}
                                                        </button>
                                                        <button
                                                            type="submit"
                                                            className="btn btn-success me-1 mb-1"
                                                            disabled={!concordaConvite || isSubmitting || !data?.htmlCartaConvite}
                                                            onClick={() => { salvar(true); }}
                                                        >
                                                            <FaCheck size={20} /> {getText('acceptInvite', idioma)}
                                                        </button>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section >
            </div >
        </ErpTemplate >
    );
}
